/*
 * Copyright (c) 2024-2026, s0up and the autobrr contributors.
 * SPDX-License-Identifier: GPL-2.0-or-later
 */

const SESSION_TOKEN_KEY = "nyrvex-session-token";

export function getSessionToken(): string {
  return localStorage.getItem(SESSION_TOKEN_KEY) || "";
}

export function setSessionToken(token: string) {
  if (token) {
    localStorage.setItem(SESSION_TOKEN_KEY, token);
  }
}

export function clearSessionToken() {
  localStorage.removeItem(SESSION_TOKEN_KEY);
}

// withSessionToken previously appended the session token as an ?auth_token
// query parameter for EventSource/<img> requests that cannot set an
// Authorization header. That leaked the token into access logs, history and
// Referer headers. Same-origin requests send the httpOnly session cookie
// automatically, so the URL is now returned unchanged. Kept as a pass-through
// so existing callers need no change.
export function withSessionToken(url: string): string {
  return url;
}

export function installSessionFetch() {
  const originalFetch = window.fetch.bind(window);
  window.fetch = (input: RequestInfo | URL, init: RequestInit = {}) => {
    const token = getSessionToken();
    if (!token) {
      return originalFetch(input, init);
    }

    const headers = new Headers(init.headers);
    if (!headers.has("Authorization")) {
      headers.set("Authorization", `Bearer ${token}`);
    }

    return originalFetch(input, {
      ...init,
      credentials: init.credentials || "include",
      headers,
    });
  };
}
